import { motion, AnimatePresence } from "framer-motion";
import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/use-online-status";
import { cn } from "@mira/ui";

interface OfflineBannerProps {
  sidebarCollapsed?: boolean;
}

export function OfflineBanner({ sidebarCollapsed }: OfflineBannerProps) {
  const isOnline = useOnlineStatus();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className={cn(
            "fixed top-16 z-50 bg-coral-alert text-pure-white px-4 py-2.5 text-center text-sm font-medium flex items-center justify-center gap-2",
            "left-0 right-0",
            sidebarCollapsed ? "lg:left-[72px]" : "lg:left-[260px]",
          )}
        >
          <WifiOff className="w-4 h-4 shrink-0" />
          <span>You are offline. Some features may not work.</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
